// extracted by mini-css-extract-plugin
module.exports = {"root":"_1FOtL","loading":"_2WhM6","preloader":"_2O0un","semi-rotate":"m8SlT","semiRotate":"m8SlT","inner-rotate":"RYf6t","innerRotate":"RYf6t"};